<template>
  <div style="height: 100%">
    <v-main>
      <transition name="fade" mode="out-in" appear>
        <v-flex class="d-flex fill-height align-md-center justify-center">
          <router-view></router-view>
        </v-flex>
      </transition>
    </v-main>
  </div>
</template>

<script>

export default {
  name: "ShorterLayout",
}
</script>
